<script setup lang="ts">
import type { IconDefinition } from '@fortawesome/duotone-regular-svg-icons'
import { useI18n } from 'vue-i18n'

const { index } = defineProps<{
  selected: boolean
  index: number
  theme: Record<string, string>
  icon?: IconDefinition
}>()

const { t } = useI18n()

const classes = 'font-inter border-2 bg-(--bg) px-2 py-1 text-md md:text-[1rem] font-medium whitespace-nowrap text-(--text) '
  + 'transition-all hover:bg-(--hover-bg) hover:text-(--hover-text) focus-visible:ring md:px-5 items-center'
</script>

<template>
  <button
    :class="classes"
    :style="selected
      ? {
        'borderColor': theme[50],
        '--bg': theme[50],
        '--text': theme[10],
        '--hover-bg': theme[50],
        '--hover-text': theme[10],
      }
      : {
        'borderColor': theme[50],
        '--bg': theme[10],
        '--text': theme[50],
        '--hover-bg': theme[50],
        '--hover-text': theme[10],
      }"
  >
    <span class="flex items-center gap-2">
      <font-awesome-icon v-if="icon" :icon />
      {{ t('article.articleSub', { number: index + 1 }) }}
    </span>
  </button>
</template>
